import { Record } from "immutable";
import moment from "moment";
import { IDeliveryWindowType } from "constants/delivery-window-types";

const defaults = {
    _id: undefined,
    adjustable_dates: true,
    display_name: "",
    earliest_available_date: undefined,
    end: undefined,
    latest_available_date: undefined,
    prebook: true,
    start: undefined,
    type: undefined,
    origin: undefined,
    lineItemId: undefined, // this is for `show_ordered_qty` on Old PDP
};

export class DeliveryWindow extends Record(defaults) {
    declare adjustable_dates: boolean;
    declare prebook: boolean;
    declare display_name: string;
    declare earliest_available_date: moment.Moment;
    declare latest_available_date: moment.Moment;
    declare start: moment.Moment;
    declare end: moment.Moment;
    declare _id: string;
    declare type: IDeliveryWindowType;
    declare origin: string;
    declare lineItemId?: string; // this is for `show_ordered_qty` on Old PDP

    constructor(args) {
        super({
            ...args,
            earliest_available_date: args.earliest_available_date && moment.utc(args.earliest_available_date),
            end: args.end && moment.utc(args.end),
            latest_available_date: args.latest_available_date && moment.utc(args.latest_available_date),
            start: args.start && moment.utc(args.start),
        });
    }
}

// Entities type
export interface IDeliveryWindowEntities {
    [deliveryWindow: string]: DeliveryWindow;
}
